/** Shared bordered chrome for mobile inbox / list filter controls. */
export const MOBILE_FILTER_CHROME_CLASS =
  'rounded-[10px] border border-[#E5E5EA] bg-white shadow-[0_1px_2px_rgba(0,0,0,0.05)]';
